import { FC, useState } from "react";
import { Button, Form, Input } from "antd";
import { useAppDispatch, useAppSelector } from "../../../store";
import { updatePassword } from "../../../store/actions/registrationAction";
import { passValid } from "../../../utils";
import styles from "./styles.module.css";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { tabsNamesKeys } from "../Registration.models";

interface IPasswordFormValues {
  password: string;
  confirm: string;
}

interface IPasswordProps {
  setStep: (step: tabsNamesKeys) => void;
}

export const Password: FC<IPasswordProps> = ({ setStep }) => {
  const dispatch = useAppDispatch();
  const { _isLoading, email, _isForeignPhone } = useAppSelector(
    (state) => state.registrationSlice
  );

  const [form] = Form.useForm<IPasswordFormValues>();

  const [isSubmittable, setIsSubmittable] = useState(false);

  const onFinishHandler = () => {
    const password = form.getFieldValue("password");
    if (!isSubmittable) {
      return;
    }

    dispatch(updatePassword({ password }));
  };

  const onValuesChangeHandler = (_: any, allValues: IPasswordFormValues) => {
    const { password, confirm } = allValues;
    const isValid =
      Boolean(password?.length) &&
      Boolean(confirm?.length) &&
      password === confirm;

    setIsSubmittable(isValid);
  };

  return (
    <div>
      <p className={styles.subtitle}>Введите ваши личные данные</p>

      <Form
        form={form}
        name="passwordForm"
        layout="vertical"
        onFinish={onFinishHandler}
        onValuesChange={onValuesChangeHandler}
      >
        <Form.Item
          name="password"
          rules={[
            { required: true, message: "Пожалуйста, введите ваш пароль" },
            {
              validator(_, value) {
                if (value && value.length < 5) {
                  return Promise.reject(
                    "Пароль должен содержать не менее 5 символов"
                  );
                }
                if (value && !value.match(passValid)) {
                  return Promise.reject(
                    "Пароль может содержать цифры, символы и латинские буквы"
                  );
                }

                return Promise.resolve(true);
              },
            },
          ]}
          hasFeedback
        >
          <Input.Password
            allowClear
            placeholder="Пароль"
            className={styles.input}
          />
        </Form.Item>
        <Form.Item
          name="confirm"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Пожалуйста, введите ваш пароль" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const passwordValue = getFieldValue("password");

                if (passwordValue === value) {
                  return Promise.resolve();
                }
                if (passwordValue === "") {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Пароли не совпадают"));
              },
            }),
          ]}
          hasFeedback
        >
          <Input.Password
            placeholder="Подтверждение пароля"
            className={styles.input}
            allowClear
          />
        </Form.Item>
        <p className={styles.hint}>
          Введенный пароль будет использоваться для входа в систему. <br />
          Пароль должен содержать латинские буквы, символы и цифры.
        </p>
        <Form.Item shouldUpdate>
          <Button
            type="primary"
            className={styles.nextButton}
            disabled={!isSubmittable || _isLoading}
            htmlType="submit"
          >
            Продолжить
          </Button>
          {!email && !_isForeignPhone && (
            <Button
              type="link"
              icon={<ArrowLeftOutlined />}
              className={styles.backButton}
              onClick={setStep.bind(null, tabsNamesKeys.email)}
            >
              Вернуться к вводу email
            </Button>
          )}
        </Form.Item>
      </Form>
    </div>
  );
};
